import { ProblemStatistics } from '@/domain/entities/problem/problemStatistics'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'

export class GetProblemStatisticsUseCase {
  constructor(private repository: ProblemRepository) {}

  async getProblemStatistics(problemId: string): Promise<ProblemStatistics> {
    try {
      const data = await this.repository.getProblemStatistics(problemId)
      return data
    } catch (error) {
      console.error(`Error in GetProblemStatisticsUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
